import { AdminKlanttraject } from '../admin/AdminKlanttraject';

export function SupportKlanttraject() {
  return <AdminKlanttraject />;
}
